import { Box, SxProps, Theme } from "@mui/material";
import React from "react";
import {
  TruncateTypography,
  type TruncateTypographyProps,
} from "./TruncateTypography";

type TruncateDataGridCellProps = {
  containerSx?: SxProps<Theme>;
} & TruncateTypographyProps;

export const TruncateDataGridCell = ({
  containerSx,
  sx,
  ...truncateTypographyProps
}: TruncateDataGridCellProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        minWidth: 0,
        ...containerSx,
      }}
    >
      <TruncateTypography
        sx={{ flex: 1, minWidth: 0, ...sx }}
        {...truncateTypographyProps}
      />
    </Box>
  );
};
